// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__Me_mY","rootSmall":"AddTileButton_rootSmall__1nLrI"};